// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"158":"labels","332":"detail","594":"about","852":"orders"}[chunkId] || chunkId) + "." + {"158":"f6f1d938","332":"3146af6b","594":"e7b25051","852":"3146af6b","998":"4ee610b9"}[chunkId] + ".css";
};